import Flex from 'frontend/commons/Flex';
import timeDiffBetweenDates from 'frontend/utils/time-diff-between-dates';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  MdOutlineArrowCircleLeft,
  MdOutlineArrowCircleRight,
  MdOutlineChangeCircle,
} from 'react-icons/md';
import FlightDate from '../FlightDate';

const iconByMoveCode = {
  start: <MdOutlineArrowCircleRight />,
  intermediate: <MdOutlineChangeCircle />,
  end: <MdOutlineArrowCircleLeft />,
};

const FlightInfoItem = ({
  departureDate,
  arrivalDate,
  travelCode,
  nextDepartureDate,
  originCity,
  destinationCity,
  flightCompany,
  thisMove,
  totalMoves,
}) => {
  const { t } = useTranslation(['layout']);

  const duration = timeDiffBetweenDates(departureDate, arrivalDate);
  const awaitBetweenFlights = nextDepartureDate
    ? timeDiffBetweenDates(arrivalDate, nextDepartureDate)
    : undefined;

  const moveCode = useMemo(
    () => (!thisMove ? 'start' : totalMoves === thisMove ? 'end' : 'intermediate'),
    [totalMoves, thisMove],
  );

  return (
    <Flex className="package-card__dynamic-content__wrapper__flight-list__records__item">
      <Flex className="package-card__dynamic-content__wrapper__flight-list__records__item__header">
        <p>{flightCompany ?? '--------'}</p>
        <Flex className="package-card__dynamic-content__wrapper__flight-list__records__item__details__travel-code">
          COD. {travelCode}
        </Flex>
      </Flex>
      <Flex className="package-card__dynamic-content__wrapper__flight-list__records__item__info">
        <Flex className="package-card__dynamic-content__wrapper__flight-list__records__item__info__details">
          <Flex className="package-details__dynamic-content__wrapper__flight-list__records__item__details">
            <Flex
              title={`${t(`packages.trip_type.${moveCode}`)}${
                moveCode === 'intermediate' ? ` ${thisMove}` : ''
              }`}
              className="package-details__dynamic-content__wrapper__flight-list__records__item__info__type"
            >
              <span
                className={`package-card__dynamic-content__wrapper__flight-list__records__item__info__type__trip-type trip-${moveCode}`}
              >
                {iconByMoveCode[moveCode]}
              </span>
              {moveCode === 'intermediate' && (
                <span className="package-card__dynamic-content__wrapper__flight-list__records__item__info__type__move">
                  {thisMove}
                </span>
              )}
            </Flex>
            <FlightDate location={originCity.codigoCiudad} date={departureDate} />
            <Flex className="package-card__dynamic-content__wrapper__flight-list__records__item__details__separator"></Flex>
            <FlightDate location={destinationCity.codigoCiudad} date={arrivalDate} />
          </Flex>
        </Flex>
        <Flex
          vertical
          className="package-card__dynamic-content__wrapper__flight-list__records__item__end"
        >
          <p>
            <strong>{t('packages.duration')}</strong>: {duration}
          </p>
          {awaitBetweenFlights && (
            <p>
              <strong>{t('packages.airport_await')}</strong>: {awaitBetweenFlights}
            </p>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FlightInfoItem;
